<script>
    import { onMount } from 'svelte';
	import { t, locale, locales } from "../i18n.js";
    import { fade } from "svelte/transition";
	import { each } from 'svelte/internal';
	import {get, writable} from 'svelte/store';

	let vr_type = '';

	import {loaded_krpano, tour_select} from "../store.js";
	import { vr_mode } from '../store.js';
	import { device_type } from '../store.js';
	import { gyro_mode } from '../store.js';

	import { floor} from '../store.js';

	let _floor = "1";

	floor.subscribe((value) => {
		_floor = value;
		console.log(_floor);
	});

	export let userdata;

	export let location;
	let tmp = location;
    let showTour = false;


	import Basket from '../tour_components/Basket.svelte';
	import Languages from '../tour_components/Languages.svelte';
	import Logo from '../tour_components/Logo.svelte';
	import Sidebar from '../tour_components/Sidebar.svelte';
	import Shortcuts from '../tour_components/Shortcuts.svelte';
	// import Intro from '../tour_components/Intro.svelte';
	import Floorplan from '../tour_components/Floorplan.svelte';
	import Blur from '../tour_components/Blur.svelte';
	import Picker from '../tour_components/Picker.svelte';
	import Vr_tools from '../tour_components/Vr_tools.svelte';

	function webvr_state() {
		let krpano = document.getElementById("krpanoSWFObject")
		//vr_mode = krpano.webvr && krpano.webvr.isenabled ? krpano.webvr.isfake ? krpano.webvr.iswebvr ? 3 : 1 : 2 : 0;
		// 0=off, 1=fake, 2=mobile, 3=true webvr (oculus go, rift, etc)	
		vr_type = krpano.webvr && krpano.webvr.isenabled ? krpano.webvr.isfake ? krpano.webvr.iswebvr ? krpano.webvr.isvrbrowser ? 3 : 1 : 2 : 0 : 14;
		// device_type.update(n => krpano.webvr && krpano.webvr.isenabled ? krpano.webvr.isfake ? krpano.webvr.iswebvr ? krpano.webvr.isvrbrowser ? 3 : 1 : 2 : 0 : 14);
		// console.log('TYPE : ' + vr_type);	
		// return krpano.webvr && krpano.webvr.isenabled ? krpano.webvr.isfake ? krpano.webvr.iswebvr ? 3 : 1 : 2 : 0;
	}

	const initializeRemarkable = () => {
		fetchData(test);
	}

	let settings;
	let loading_data = true;
	let start_scene;
	let start_scene_number = 0;

	let krpano_full_loaded = false;

	let enable_sound = false;

	function set_target() {
		let tmp_data = settings;

		console.log(tmp_data);

		for (let index = 0; index < tmp_data.scenes.length; index++) {		
			if (
				tmp_data.scenes[index].hotspots
			) {
				console.log('scéna : '+ tmp_data.scenes[index].name);
				let new_target;
				let start_numb = -3;

				for (let i = 0; i < tmp_data.scenes[index].hotspots.length; i++) {
					if (
						tmp_data.scenes[index].hotspots[i].name.indexOf('next-node') != -1 && tmp_data.scenes[index].hotspots.length > 5
					) {

						if ( i == 3) {
							new_target = 1;
							start_numb = 2;
							
						}

						else {
							new_target = start_numb;
								start_numb ++;
						}

						tmp_data.scenes[index].hotspots[i].new_taget = new_target;
					
										
						console.log('starý target : ' + tmp_data.scenes[index].hotspots[i].target + ' | nový target : ' + tmp_data.scenes[index].hotspots[i].new_taget + '(' + i + ')');


					}

					else {
						
						tmp_data.scenes[index].hotspots[i].new_taget = null;
					}
					
				
				}
			}
		}

		settings = tmp_data;
		console.log(settings.scenes);

		// for (let index = 0; index < tmp_data.scenes.length; index++) {
			
		// 	let start_numb = -3;
			
		// 	for (let i = 0; index < tmp_data.scenes[index].hotspots.length; i++) {
				
		// 		// if (
		// 		// 	tmp_data.scenes[index].hotspots[i] && tmp_data.scenes[index].hotspots[i].name.indexOf('next-node') != -1
		// 		// ) {
		// 		// 	let old_target = tmp_data.scenes[index].hotspots[i].name;
		// 		// 	let new_target;
		// 		// 	switch (i) {
		// 		// 		case  i > -1 :
		// 		// 			new_target = i + 1;
		// 		// 			break;
					
		// 		// 		default:
		// 		// 			new_target = start_numb;
		// 		// 			break;
		// 		// 	}

		// 		// 	start_numb++;	
				
		// 		// 	console.log(old_target + "|" +   new_target);
		// 		// }
		// 	}
		// }
		

		

		
		
	}

	function import_dummy_data() {
		let count = 6;
		let tmp_data = settings;

		let object_depth = {
			0 : {
				depth : 2000,
				size : "2",
				rx : -70,
				h : -90,
				v : 6
			},
			1 : {
				depth : 1400,
				size : "3",
				rx : -60,
				h : -90,
				v : 11
			},
			2 : {
				depth : 1000,
				size : "4",
				rx : -40,
				h : -90,
				v : 22
			},
			3 : {
				depth : 1000,
				size : "4",
				rx : -40,
				h : -90,
				v : 22
			},
			4 : {
				depth : 1400,
				size : "3",
				rx : -60,
				h : -90,
				v : 11
			},
			5 : {
				depth : 2000,
				size : "2",
				rx : -70,
				h : -90,
				v : 6
			}
		}
		
		for (let index = 0; index < tmp_data.scenes.length; index++) {
			tmp_data.scenes[index].hotspots = [];

			let poradie = -1;
			let tmp_ath = -90;
			let tmp_atv = 22;
			let tmp_depth = 1000;  
			let tmp_rx = -40;



			for (let i = 0; i < count; i++) {
				let hodnota;

				switch (i) {
					case 0 : 
						hodnota = index - 3;
					break;

					case 1 : 
						hodnota = index - 2;
					break;

					case 2 : 
						hodnota = index - 1;
					break;

					case 3 : 
						hodnota = index + 1 ;
					break;

					case 4 : 
						hodnota = index + 2 ;
					break;

					case 5 : 
						hodnota = index + 3 ;
					break;
				}


				let dummy_data = {
					id : i,
					name : "next-node_" + i,
					title : "",
					description : "",
					type : "next-node",
					"skin-id" : "floorspot",
					target : "praha_" + hodnota,
					enabled : true,
					ath :  object_depth[i].h,
					atv : object_depth[i].v,
					depth : object_depth[i].size,
					depth_value : object_depth[i].depth,
					rx : object_depth[i].rx,
					ry : 0, 
					data : {
						title : "",
						headline : "",
						img : "img/38.jpg",
						subtitle : "subtitle pre modal",
						content : "content pre modal",
						video_url :"",
						local_video_url : ""
					}
				};



				tmp_data.scenes[index].hotspots.push(dummy_data);
			}

				


			
			
			// for (let i = 0; index < count.length; i++) {
				
				
			// 	let poradie = -1;
			// 	let tmp_ath = -90;
			// 	let tmp_atv = 22;
			// 	let tmp_depth = 1000;  
			// 	let rx = -40;


			// 	// -1

				
			// 	// tmp_data.scenes[index].hotspots[i] = {
			// 	// 	id : i,
			// 	// 	name : "next-node_" + i,
			// 	// 	title : "",
			// 	// 	description : "",
			// 	// 	type : "next-node",
			// 	// 	"skin-id" : "floorspot",
			// 	// 	target : "praha_" + poradie,
			// 	// 	enabled : true,
			// 	// 	ath :  tmp_ath,
			// 	// 	atv : tmp_atv,
			// 	// 	depth : tmp_depth,
			// 	// 	rx : tmp_rx,
			// 	// 	ry : 0, 
			// 	// 	data : {
			// 	// 		title : "",
			// 	// 		headline : "",
			// 	// 		img : "img/38.jpg",
			// 	// 		subtitle : "subtitle pre modal",
			// 	// 		content : "content pre modal",
			// 	// 		video_url :"",
			// 	// 		local_video_url : ""
			// 	// 	}
			// 	// };

			// }
		}

		console.log(tmp_data);
	}

	// Načítanie scén
	async function fetchData() {
		const res = await fetch(
			// "https://woowstudio.com/molly/praha/assets/json/settings.json",
			userdata['base_path'] + "assets/json/settings.json",
		{}
		);

		if (res.ok) {
		const json = await res.json();
		settings = json;
		start_scene = settings.configuration.start_scene;

			// console.log(settings);
		loading_data = false;
		showTour = true;

		function check_pano() {
			var krpano = document.getElementById("pano");
			if(typeof(krpano) != 'undefined' && krpano != null){
				load_krpano();
			} else{
			setTimeout(check_pano, 100);
			}
		}

      	check_pano();

		//  import_dummy_data();

		



		return json;
		} else {
		throw new Error(data);
		}
  	}

	const components = [Logo, Shortcuts,Sidebar,Sounds,Floorplan];
	const components_array = ["Logo", "Shortcuts","Sidebar","Sounds","Floorplan"];

	import { active_scene } from '../store.js';

	function floorspot_animation($par) {
		
	}

	// Načítanie krpana
  	function load_krpano () {
		embedpano({
			xml: userdata['base_path'] + "assets/krpano/tour.xml",
			target:"pano",
			html5:"only",
			mobilescale:1.0,
			initvars : {
				scene_name : "tmp",
				show_hs : true,
				floor : _floor
			},
			hooks: {
            loadSceneData(scene) {
            },
            sceneChanged(scene) {
            }
        },
			onready: function (krpano) {
				let loaded_times = 0;
				var krpano = krpano.get("global");
				//console.log(settings.configuration.start_scene);
				krpano.call("loadscene(" + settings.configuration.start_scene + ")");
				webvr_state();
				let data = [
					{ 
						scene : 'praha_0',
						id : "info_9",
						title : "Sadová třída",
						content : "Sadová třída patřila k reprezentativním pražským ulicím. Vznikla po zrušení novoměstských hradeb a stala se důležitou komunikací od nové budovy centrálního nádraží k Václavskému náměstí. Podél Sadové třídy vznikaly významné stavby. Kromě nádraží to byla budova Německého divadla (dnešní Státní opera), dále neoklasicistní budova Peněžní bursy (v 70. letech přestavěná v brutalistním stylu na Federální shromáždění; dnes součást Národního muzea), populární hotel Wilson a jedinečným dílem byl i reprezentativní neorenesanční činžovní dům, projektovaný Antonínem Wiehlem a dekorovaný známým malířem Jakubem Schikanederem. Léta tzv. normalizace byla pro ráz velkoměstské třídy doslova zhoubná. Zmizely široké chodníky s alejí stromů, žulová dlažba i velmi užitečná tramvajová trať. Místo toho zde vznikla místy vyvýšená komunikace, jež stáhla průjezdnou dopravu z velké části metropole. Z přívětivé a velkorysé ulice tak vznikla jakási dálnice v Praze, jež se stala současně i výraznou bariérou, oddělující čtvrti Nové Město a Vinohrady",
						img : "assets/img/infopanel pre Sadová Trída.jpg"
					},
					{ 
						scene : 'praha_69',
						id : "info_6",
						title : "Historická budova Hlavního nádraží",
						content : "Výpravní budova architekta Josefa Fanty je součástí hlavního nádraží v Praze a spolu s přilehlou halou nad nástupišti tvoří největší secesní památku v Česku. Budova z let 1902-1909 je tvořená monumentální odjezdovou halou, sevřenou mezi pylonovými věžemi. Věže jsou zdobeny alegorickými sochami Stanislava Suchardy, Hanuše Folkmanna, plastikami Géniů Čeňka Vosmíka a okřídleným kolem, symbolem železnice. Kolejiště zastřešuje v Čechách ojedinělá nádražní hala se skleněnou střechou na ocelových obloucích. Nádraží neslo jméno císaře Františka Josefa, od roku 1919 Woodrowa Wilsona, které se od roku 1990 při mimořádných historických a oficiálních událostech opět používá",
						img : "assets/img/infopanel pre Hlavni Nadraží.jpg"
					},
					{ 
						scene : 'praha_19',
						id : "info_6",
						title : "Německé divadlo (dnešní Státní opera)",
						content : "Nové divadlo si nechala na sklonku 80. let 19. století vystavět pražská německá obec. Novorenesanční budova s neorokokovým interiérem koncipovaná podle plánů vídeňských architektů Ferdinanda Fellnera a Hermanna Helmera přinesla Praze jevištními parametry a kapacitou hlediště nejvelkorysejší divadelní prostor, který si svoje prvenství podržel dodnes. Ve 30.letech v době sílícího nacistického nebezpečí patřilo Nové německé divadlo v Praze k demokratickým baštám, kam se uchylovali umělci, jejichž působení v sousedním Německu již bylo nežádoucí. Divadlo ukončilo činnost v září 1938.",
						img : "assets/img/infopanel pre Nemecke Divadlo 02.jpg"
					},

					{ 
						scene : 'praha_30',
						id : "info_6",
						title : "Hotel Wilson",
						content : "Úspěšný architekt, stavitel i hoteliér Alois Krofta postupně ve 20. a 30.letech vystavěl několik hotelů – Wilson, Splendid na Letné a Alcron na Václavském náměstí. Palác Flora na Vinohradech budoval ve dvou etapách. Hotel Wilson měnil v průběhu času jméno, za nacistické okupace na Astorii a po nástupu komunistů se přejmenoval na Slovan.",
						img : "assets/img/infopanel pre Hotel Wilson 02.jpg"
					},

					{ 
						scene : 'praha_9',
						id : "info_6",
						title : "Pražská burza peněžní a zbožní",
						content : "Budova byla otevřena 24. února 1938. Vyprojektoval ji český architekt Jaroslav Rössler, žák slavného Jana Kotěry. Pražská burza zde ale dlouho nefungovala. 15. březen roku 1939 a nástup okupační moci ukončil její činnost. Za druhé světové války zde bylo skladiště, na konci války  lazaret. Po válce sem bylo umístěno Národní shromáždění – parlament Československé republiky. Následně byla budova včleněna do komplexu nového Federálního shromáždění.",
						img : "assets/img/infopanel pre Pražská burza.jpg"
					},

					{ 
						scene : 'praha_73',
						id : "info_6",
						title : "Pomník Woodrowa Wilsona",
						content : "Pomník byl odhalen 4. července 1928 v rámci oslav 10.výročí vzniku Československa a věnován americkému prezidentu Woodrow Wilsonovi, který se podstatně zasloužil o poválečnou organizaci Evropy včetně vzniku Československa. Původně pomník stával přímo naproti historické budově Wilsonova nádraží. Krátce poté, co Německo vyhlásilo válku USA (1941) německá okupační správa přikázala Wilsonovu sochu strhnout a zničit. Původní místo ve Vrchlického sadech, kde socha stávala, bylo pak v 70.letech zastavěno novou nádražní halou. Pomník byl obnoven v roce 2011 ve Vrchlického sadech blíže k Opletalově ulici.",
						img : "assets/img/infopanel pre W. Wilsona.jpg"
					},

					{ 
						scene : 'praha_0',
						id : "info_6",
						title : "Dům na rohu Václavského náměstí a Washingtonovy ulice",
						content : "Dům s výraznou věží zde stál od 80. let 19. století. Jeho výrazná věž v pohledu konkurovala budově Národního muzea. Dům byl těžce poškozen při bombardování v posledních dnech války v květnu 1945 a následně zbourán. Na parcele byl po válce v letech 1954–1957 postaven objekt obchodního domu, původně obchodní dům Pramen, později známý spíše jako Dům potravin. Po sametové revoluci zde sídlila pobočka obchodního domu Bílá Labuť, v současnosti je stavba využívána jako hotel",
						img : "assets/img/1INfopanel Dům na rohu Václavského náměstí a Washingtonovy ulice.jpg"
					},

					{ 
						scene : 'praha_41',
						id : "info_6",
						title : "Městský park – Vrchlického sady",
						content : "Kolem nově vystavěného nádraží císaře Františka Josefa I. (v roce 1871) byl založen Velký park, později pojmenován Městský velký park. Obsahoval rybník s ostrůvkem, květinové partery, skály s umělým vodopádem. Roku 1884 byl park rozšířen o další plochu, která byla dle návrhu zahradního architekta, jednoho z nejlepších, Františka Thomayera, upravena a vyzdobena květinami. Kdysi býval označován za nejkrásnější v Praze. Roku 1913 byl park přejmenován na Vrchlického sady. V 70. letech byl park od třídy oddělen novostavbou odbavovací haly nádraží",
						img : "assets/img/infopanel pre Park Vrchlickeho sady 02.jpg"
					},

					{ 
						scene : 'praha_34',
						id : "info_6",
						title : "Neorenesanční dům č.p. 94",
						content : "Blok zajímavých domů musel ustoupit výstavbě metra a Severojižní magistrály",
						img : "assets/img/infopanel pre Neorenesanční dům č.p. 94.jpg"
					},

					{ 
						scene : 'praha_27',
						id : "info_6",
						title : "Demolice bloku domů č.p. 94-96 (včetně hotelu Wilson)",
						content : "Jedinečným dílem byl reprezentativní neorenesanční činžovní dům, projektovaný na sklonku 19.století Antonínem Wiehlem a dekorovaný známým malířem Jakubem Schikanederem. Ten byl, stejně jako další budovy na této straně ulice, později zbourán v souvislosti s budováním nejstarší části pražského metra a později i Severojižní magistrály.",
						img : "assets/img/infopanel pre Demolice objektu Sadová Trída.jpg"
					},

					{ 
						scene : 'praha_46',
						id : "info_6",
						title : "Budova rychlozboží",
						content : "Tato provozní budova nádraží sloužila jako skladiště a byla přibližně v polovině dvacátých let 20.století zbourána.",
						img : ""
					},

					{ 
						scene : 'praha_0',
						id : "info_8",
						title : "Poděkování",
						content : "",
						img : "assets/img/infopanel pre Na konci prehliadky na oboch koncoch ulice.jpg"
					},

					{ 
						scene : 'praha_80',
						id : "info_3",
						title : "Poděkování",
						content : "",
						img : "assets/img/infopanel pre Na konci prehliadky na oboch koncoch ulice.jpg"
					},
					{ 
						scene : 'praha_78',
						id : "info_5",
						title : "Historická budova Hlavního nádraží",
						content : "Výpravní budova architekta Josefa Fanty je součástí hlavního nádraží v Praze a spolu s přilehlou halou nad nástupišti tvoří největší secesní památku v Česku. Budova z let 1902-1909 je tvořená monumentální odjezdovou halou, sevřenou mezi pylonovými věžemi. Věže jsou zdobeny alegorickými sochami Stanislava Suchardy, Hanuše Folkmanna, plastikami Géniů Čeňka Vosmíka a okřídleným kolem, symbolem železnice. Kolejiště zastřešuje v Čechách ojedinělá nádražní hala se skleněnou střechou na ocelových obloucích. Nádraží neslo jméno císaře Františka Josefa, od roku 1919 Woodrowa Wilsona, které se od roku 1990 při mimořádných historických a oficiálních událostech opět používá",
						img : "assets/img/infopanel pre Hlavni Nadraží.jpg"
					},
					{ 
						scene : 'praha_0',
						id : "video_7",
						title : "Demolice domu naproti Národnímu muzeu",
						content : "",
						img : "assets/videos/local_video.mp4"
					},
					{ 
						scene : 'praha_41',
						id : "video_7",
						title : "Jaro v Praze",
						content : "",
						img : "assets/videos/local_video2.mov"
					}
				];

				krpano.events.onnewpano = function() {
					current_scene = krpano.get("xml.scene").replace('scene_','').toUpperCase();
					active_scene.update(n => krpano.get("xml.scene").replace('scene_','').toUpperCase());

					// console.log(get(vr_mode));
					if (
						get(vr_mode) == true
					) {
						console.log(get(active_scene).toLowerCase());
						var hs = krpano.get("hotspot[info]");
						var hts_count = krpano.get("hotspot.count");
						console.log(hts_count);

					for (let index = 0; index < hts_count; index++) {

						var hts_name = krpano.get("hotspot[" + index +"].name");
						
						if (
							krpano.get("hotspot[" + index +"].name").includes("video")) {
							// krpano.set("hotspot[" + index +"].alpha", "0.0");
							// krpano.set("hotspot[" + index +"].visible", "false");
						}

						if (
							krpano.get("hotspot[" + index +"].name").includes("info") || krpano.get("hotspot[" + index +"].name").includes("video")) 

						 {
							
							// console.log(get(active_scene).toLowerCase());
							for (let index = 0; index < data.length; index++) {
								
								if (
									data[index].scene == get(active_scene).toLowerCase() && data[index].id == hts_name
								) {
									// console.log(data[index].title);
									let title = data[index].title;
									let headline = data[index].content;
									let img = data[index].img.replace('assets/','');

									// console.log(title + ' | ' + headline + ' | '  + img);
									krpano.set("hotspot[" + hts_name + "].onclick", "js(tour_hts_info(true, " + hts_name + "," + title + "," + headline + "," + img + "););");
								}
								
								
							}
							

						}
						
					}

					}


					else {
						var hs = krpano.get("hotspot[info]");
						var hts_count = krpano.get("hotspot.count");

						for (let index = 0; index < hts_count; index++) {
							if (
								krpano.get("hotspot[" + index +"].name").includes("info") ||
								krpano.get("hotspot[" + index +"].name").includes("video")	
							) {
								
								krpano.set("hotspot[" + index +"].alpha", "1.0");
								krpano.set("hotspot[" + index +"].visible", "true");
								// console.log(krpano.get("hotspot[" + index +"].name"));
								//console.log(krpano.get("hotspot[" + index +"].hstype").split('-').pop().replace('v',''));

								var hs = krpano.get("hotspot[" + index +"]");
								hs.onclick = function() {

									hts_id = krpano.get("hotspot[" + index +"].id");
									if (
										krpano.get("hotspot[" + index +"].hstype").includes('info') != null
									) {
										modal_type.set('info-v'+ krpano.get("hotspot[" + index +"].hstype").split('-').pop().replace('v',''));
									}

									if (
										krpano.get("hotspot[" + index +"].hstype").includes('video')
									) {
										modal_type.set('video-v2');
									}

									modal.update(n => !n);
								}
							}

						}
					}
				}

				krpano.events.onloadcomplete = function() {

					
				
					

					if (
						loaded_times < 1
					)
					{
						
						krpano_full_loaded = true;
						loaded_krpano.update(n => !n);

						setTimeout(function() {
							preloader.update(n => !n);
							enable_sound = true;
							tour_select.update(n => true);


						}, 1500);
					}
					
					loaded_times++;

				};

				krpano.events.onunknowndevice = function () {
					device_type.update(n=> 555);
				}

				krpano.events.webvr_onexitvr = function() {
					
					
					vr_mode.update(n => false);
					var hts_count = krpano.get("hotspot.count");

						for (let index = 0; index < hts_count; index++) {
							if (
								krpano.get("hotspot[" + index +"].type").includes("infopanel-v1") || krpano.get("hotspot[" + index +"].type").includes("infopanel-v2") || krpano.get("hotspot[" + index +"].type").includes("infopanel-v3") ||
								krpano.get("hotspot[" + index +"].type").includes("videopanel-v1")	|| krpano.get("hotspot[" + index +"].type").includes("videopanel-v2")	
							) {


								krpano.set("hotspot[" + index +"].alpha", "1.0");
								krpano.set("hotspot[" + index +"].visible", "true");

								var hs = krpano.get("hotspot[" + index +"]");
								hs.onclick = function() {

									hts_id = krpano.get("hotspot[" + index +"].id");
									if (
										krpano.get("hotspot[" + index +"].hstype").includes('info') != null
									) {
										modal_type.set('info-v'+ krpano.get("hotspot[" + index +"].hstype").split('-').pop().replace('v',''));
									}

									if (
										krpano.get("hotspot[" + index +"].hstype").includes('video')
									) {
										modal_type.set('video-v2');
									}

									modal.update(n => !n);
								}
							}
						}
						

				}
				
				krpano.events.webvr_onentervr = function() {
					
					vr_mode.update(n => true);

					var hs = krpano.get("hotspot[info]");
						var hts_count = krpano.get("hotspot.count");

					for (let index = 0; index < hts_count; index++) {

						var hts_name = krpano.get("hotspot[" + index +"].name");
						if (
							krpano.get("hotspot[" + index +"].name").includes("video")) {
							// krpano.set("hotspot[" + index +"].alpha", "0.0");
							// krpano.set("hotspot[" + index +"].visible", "false");
						}

						if (
							krpano.get("hotspot[" + index +"].name").includes("info") || krpano.get("hotspot[" + index +"].name").includes("video")) 
						 {
							
							// console.log(get(active_scene).toLowerCase());
							for (let index = 0; index < data.length; index++) {
								// console.log(data[index].scene);
								if (
									data[index].scene == get(active_scene).toLowerCase() && data[index].id == hts_name
								) {
									// console.log(data[index].title);
									let title = data[index].title;
									let headline = data[index].content;
									let img = data[index].img.replace('assets/','');

									// console.log(title + ' | ' + headline + ' | '  + img);
									krpano.set("hotspot[" + hts_name + "].onclick", "js(tour_hts_info(true, " + hts_name + "," + title + "," + headline + "," + img + "););");
								}
								
								
							}
							

						}
						
					}									
				};

				krpano.events.gyro_onenable = function() {
					gyro_mode.update(n => true);
				};

				krpano.events.gyro_ondisable = function() {
					gyro_mode.update(n => false);
				};

				krpano.events.webvr_onavailable = function() {

					if (
						krpano.device.mobilevr == true && krpano.webvr.isvrbrowser
					) 
					device_type.update(n => 'vr');

				};
			}
		});
  	}


	// zapnutie / vypnutie modalu
	import { modal } from '../store.js';
	import { modal_type } from '../store.js';
	import { preloader } from '../store.js';
	import Sounds from '../tour_components/Sounds.svelte';
  	import VrTools from '../tour_components/Vr_tools.svelte';
	
	let current_scene;

	// $:current_scene = console.log(current_scene + ': ' + userdata['base_path']);
	
	let hts_id;
	let show_modal;
  	modal.subscribe(value => {
		show_modal = value;
	});


	let show_preloader;
  	preloader.subscribe(value => {
		show_preloader = value;
		if (
			document.getElementById("intro_div")
		) {
			document.getElementById("intro_div").remove();
		}
	});

  	let modal_type_tmp;

	modal_type.subscribe(value => {
		modal_type_tmp = value;
	});

  	let Modal;
	let Preloader;
	let EnterVR;
	let Intro;
	let TourSelect;

  const sleep = ms => new Promise(f => setTimeout(f, ms));

	onMount(async () => {
		//await sleep(1000); // simulate network delay
		Intro = (await import('../tour_components/Intro.svelte')).default
    	Modal = (await import('../tour_components/Modal.svelte')).default
		Preloader = (await import('../tour_components/Preloader.svelte')).default
		EnterVR = (await import('../tour_components/Enter_VR.svelte')).default
		//TourSelect = (await import('../tour_components/Tour_select.svelte')).default
	});

</script>

<svelte:head>

	<script>

		function test(name) {
			tmp_name = name;
			console.log(' a je : ' + name);
		}


	</script>

	<script src="{userdata['base_path']}assets/krpano/pano.js" on:load={initializeRemarkable}></script>


	
	{#if loading_data == false}
		<!-- {#each settings.configuration.settings.meta as {id, value}}
			{#if id == "favicon"}
				<link rel="shortcut icon" href="{userdata['base_path'] + value}">
			{/if}
			{#if id == "title"}
				<title>{value}</title>
				<meta property="og:title" content={value} />
				<meta property="twitter:title" content={value} />
			{/if}
			{#if id == "description"}
				<meta name="description" content={value} />
				<meta property="og:description" content={value} />
				<meta property="twitter:description" content={value} />
			{/if}
			{#if id == "image"}
				<meta property="og:image" content="{userdata['base_path'] + value}" />
			{/if}
			{#if id == "twitter_image"}
				<meta property="twitter:image" content="{userdata['base_path'] + value}" />
			{/if}
			{#if id == "image_alt"}
				<meta property="og:image:alt" content={value} />
				<meta property="twitter:image:alt" content={value} />
			{/if}
		{/each}

		<meta property="og:url" content={settings.configuration.settings['base_path']} />
		<meta property="twitter:url" content={settings.configuration.settings['base_path']} />
		<meta property="og:type" content="website" /> -->
	{/if}
</svelte:head>

<div id="intro_div"></div>

<!-- inicializácia krpano tour -->
<div id="pano" style="width:100%;height:100%;" >

	<noscript><table style="width:100%;height:100%;"><tr style="vertical-align:middle;"><td><div style="text-align:center;">ERROR:<br/><br/>Javascript not activated<br/><br/></div></td></tr></table></noscript>
</div>

<!-- ak je načítanie JSON súboru kompletné  -->
{#if loading_data == false}
	<svelte:component this={Blur} {settings} {userdata}/>
	{#if Preloader && show_preloader}
		<svelte:component this={Preloader}/>
	{/if}

	{#if Intro}
		<svelte:component this={Intro}/>
	{/if}
	<!-- zobrazenie povolených komponentov -->
	{#each settings.components as {id, enabled}, index}
		{#if enabled == true }
			<!-- pridaný parameter {settings} pre načítanie v komponente -->
			{#each components_array as data, i}
				
				 {#if data == id}
					 <svelte:component this={components[i]} {settings} {userdata}/>
				 {/if}
			{/each}
				 <!-- content here -->
		
			
			
		{/if}
		
	{/each}

	{#if Modal && show_modal}
		{#if modal_type_tmp === 'google-map'}
			<svelte:component this={Modal} modal_type_tmp="{modal_type_tmp}" title="{$t("components")['maps']['title']}" settings="{settings}" url="{settings.components[7].url}" filter="{settings.components[7].filter}" position="" id="" current_scene="{current_scene}"/>
		{/if}
		{#if modal_type_tmp === 'tour-info'}
			<svelte:component this={Modal} modal_type_tmp="{modal_type_tmp}" title="{$t("components")['tourinfo']['title']}" settings="{settings}" url="" filter="" position="" id="" current_scene="{current_scene}"/>
		{/if}

		{#if modal_type_tmp === 'info-v1' || modal_type_tmp === 'info-v2' || modal_type_tmp === 'info-v3' }
			<svelte:component this={Modal} modal_type_tmp="{modal_type_tmp}" title="{hts_id}" settings="{settings}" url="" filter=""  position="" id="{hts_id}" current_scene="{current_scene}"/>
		{/if}

		{#if modal_type_tmp === 'video-v1'}
			<svelte:component this={Modal} modal_type_tmp="{modal_type_tmp}" title="{hts_id}" settings="{settings}" url="" filter=""  position="" id="{hts_id}" current_scene="{current_scene}"/>
		{/if}

		{#if modal_type_tmp === 'video-v2'}
			<svelte:component this={Modal} modal_type_tmp="{modal_type_tmp}" title="{hts_id}" settings="{settings}" url="" filter=""  position="" id="{hts_id}" current_scene="{current_scene}"/>
		{/if}

	{/if}

	<svelte:component this={EnterVR}/>
	
	<svelte:component this={VrTools} {settings} {userdata}/>

	<!-- {#if vr_type == 14 || vr_type == 2 }
		
	{/if} -->

	
	
{/if}

<style lang="scss">
	  @import "../assets/scss/mixins.scss";

	#pano {
		position: absolute;
		top: 0;
		left: 0;
	}
	#intro_div {
		position: absolute;
		top: 50%;
		left: 50%;
    	transform: translate(-50%, -50%);
		width: 100%;
		height: 100%;
		background: rgba(255, 254, 254, 0.5) 0% 0% no-repeat padding-box;
  		backdrop-filter: blur(40px);
  		-webkit-backdrop-filter: blur(40px);
  		-moz-filter: blur(40px);
  		z-index: 9;
	}
</style>